/* eslint-disable camelcase */
import { KEYS_LOCALSTORAGE } from './general';
import { AreaDetail } from './areas';

export const EventType = {
  ACTION: 'action',
  VIEW: 'view',
  STATE: 'state',
};

export const EventProviders = {
  KINEDU: 'KINEDU',
  MIXPANEL: 'MIXPANEL',
  FB_PIXEL: 'FB_PIXEL',
  GTM: 'GTM',
};

export const EventProvidersColors: any = {
  KINEDU: '#278ECD',
  MIXPANEL: '#004fe2',
  FB_PIXEL: '#3b5998',
};

type searchEvent = {
  age_range_min: string,
  age_range_max: string,
  theme?: string,
  area?: string,
  skills?: string,
  keyword?: string,
  response?: string,
}
export const AppEvents = {
  FORGOT_PASSWORD: () => ({ tag: 'SPForgotPass' }),
  LOGIN_SCREEN: () => ({ tag: 'S_SPLogin' }),
  LOGIN: () => ({ tag: 'LogIn' }),
  SIGNUP_SCREEN: () => ({ tag: 'S_SPSignup' }),
  SIGNUP: () => ({ tag: 'Signup' }),
  LOG_OUT: () => ({ tag: 'LogOut' }),
  S_ACTIVITY_PLAYER: ({dap_type, ...params}: any) => {
    if (!!!params.area) {
      params.area = AreaDetail[params.area_id]?.name;
    }

    return ({
      tag: 'S_ActivityPlayer',
      params,
    })
  },
  PP_PAYMENT: ({
    tag = '',
    payment_source = '',
    response,
    interval: subscription_type,
    plan_type,
    source,
  }: any) => ({
    tag,
    params: {
      payment_source:
        payment_source
        || localStorage.getItem(KEYS_LOCALSTORAGE.WHO_REDIRECT_PPPAYMENT),
      response,
      subscription_type,
      plan_type,
      source:
        source
        || localStorage.getItem(KEYS_LOCALSTORAGE.WHO_REDIRECT_PPPAYMENT),
    },
  }),
  PPPAYMENT_PROVIDER: ({
    response,
    interval: subscription_type,
    plan_type,
    source,
  }: any) => ({
    tag: 'PPPaymentProvider',
    params: {
      response,
      subscription_type,
      plan_type,
      source:
        source
        || localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVITY_VIEW_SOURCE),
    },
  }),
  PP_PAYMENT_SUCESS: ({
    interval: subscription_type,
    plan_type,
    source,
  }: any) => ({
    tag: 'PPaymentSucess',
    params: {
      subscription_type,
      plan_type,
      source,
    },
  }),
  TAP_CALL_TO_ACTION: ({
    collection = '',
    source,
    interval: subscription_type,
    plan_type,
  }: any) => ({
    tag: 'TAPCallToAction',
    params: {
      source,
      subscription_type,
      plan_type,
      collection,
    },
  }),
  PP_PAYMENT_STARTED: ({
    interval: subscription_type,
    plan_type,
    source,
  }: any) => ({
    tag: 'PPPaymentStarted',
    params: {
      payment_source: localStorage.getItem(KEYS_LOCALSTORAGE.WHO_REDIRECT_PPPAYMENT),
      subscription_type,
      plan_type,
      source:
        source
        || localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVITY_VIEW_SOURCE),
    },
  }),
  S_CATALOG_HOME: () => ({ tag: 'S_CatalogHome' }),
  S_COLLECTION_GROUP: (collection_group: string) => ({
    tag: 'S_CollectionGroup',
    params: {
      collection_group,
    },
  }),
  ACTIVITY_VIEW: ({ area_id, id, dap_type = '', collection_group = '', collection_name = '' }: any) => {
    const params: any = {
      area: AreaDetail[area_id]?.name,
      id,
      source: localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVITY_VIEW_SOURCE),
      collection_group,
      collection_name,
    };
    if (dap_type && dap_type !== 'catalog') {
      params.dap_type = `${dap_type}Dap`;
    }
    return {
      tag: 'ActivityView',
      params,
    };
  },
  ACTIVITY_TYPE: (type: string) => ({
    tag: 'ActivityType',
    params: {
      type,
    },
  }),
  S_SEARCHER: (source: string) => ({
    tag: 'S_Searcher',
    params: {
      source,
    },
  }),
  SEARCH: ({
    age_range_min = '0',
    age_range_max = '22',
    theme,
    area,
    skills,
    keyword,
    response,
  }: searchEvent) => ({
    tag: 'Search',
    params: {
      age_range_min,
      age_range_max,
      theme,
      area,
      skills,
      keyword,
      response,
    },
  }),
  RESET_SEARCH: () => ({ tag: 'ResetSearch' }),
  S_SEARCH_RESULTS: (number_results: any) => ({
    tag: 'S_SearchResults',
    params: {
      number_results,
    },
  }),
  S_SEARCH_EMPTY_STATE: () => ({ tag: 'S_SearchEmptyState' }),
  S_COLLECTION_VIEW: ({ tab = '', collection_name }: any) => ({
    tag: 'S_CollectionView',
    params: {
      tab,
      collection_name,
    },
  }),
  ADDED_COMMENT: ({
    id = -1,
    area_id,
    role = localStorage.getItem(KEYS_LOCALSTORAGE.USER_TYPE),
  }: any) => ({
    tag: 'ActivityComments',
    params: {
      id,
      area: AreaDetail[area_id]?.name,
      role,
    },
  }),
  MARK_ACTIVITY_AS_COMPLETED: ({ activity_type, area_id, dap_type, number_students = 0 }: any) => ({
    tag: 'ActivityCompleted',
    params: {
      activity_type,
      area: AreaDetail[area_id]?.name,
      dap_type: `${dap_type}Dap`,
      source: localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVITY_VIEW_SOURCE),
      number_students,
    },
  }),
  ADJUST_ACTIVITY_THEME: ({ name: theme = '' }: any) => ({
    tag: 'AdjustActivityTheme',
    params: { theme },
  }),
  S_ACTIVITY_COMPLETED: () => ({
    tag: 'S_ActivityCompleted',
    params: {
      source: localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVITY_VIEW_SOURCE),
    },
  }),
  S_TEACHERS_NOTES: () => ({
    tag: 'S_TeachersNotes',
    params: {
      source: localStorage.getItem(KEYS_LOCALSTORAGE.CURRRENT_VIEW_COMPONENT),
    },
  }),
  S_UPDATE_MILESTONES: () => ({
    tag: 'S_UpdateMilestones',
    params: {
      source: localStorage.getItem(KEYS_LOCALSTORAGE.CURRRENT_VIEW_COMPONENT),
    },
  }),
  MILESTONES_UPDATE: (params: Record<string, any>) => ({
    tag: 'MilestonesUpdate',
    params: {
      source: localStorage.getItem(KEYS_LOCALSTORAGE.CURRRENT_VIEW_COMPONENT),
      ...params,
    },
  }),
  SCAFFOLD_DEVELOPMENT: () => ({
    tag: 'ScaffoldDevelopment',
  }),
  TAP_ACTIVITY_COMPLETED: () => ({
    tag: 'TAPActivityCompleted',
    params: {
      source: localStorage.getItem(KEYS_LOCALSTORAGE.CURRRENT_VIEW_COMPONENT),
    },
  }),
  ADD_STUDENT: (prevView: any) => ({
    tag: 'AddStudent',
    params: {
      source: localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVITY_VIEW_SOURCE),
      prevView,
    },
  }),
  DAP_ACTIVITY_COMPLETED: ({
    currentDap,
    activity,
  }: any) => {
    const { status: dapType = '' } = currentDap || {};
    const {
      area_id,
      activity_scaffolds,
      // custom_activity_owner: activityOwner,
      isCustom,
    } = activity;

    return {
      tag: 'DAPActivityCompleted',
      params: {
        scheduled_activity: '',
        activity_author: isCustom ? 'Center' : 'Kinedu',
        scaffold_version: activity_scaffolds && activity_scaffolds.length ? 'yes' : 'no',
        default_version: activity_scaffolds && activity_scaffolds.length,
        area_id,
        activity_scaffolds,
        dap_type: `${dapType}Dap`,
        area: AreaDetail[area_id]?.name,
        source: localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVITY_VIEW_SOURCE),
      },
    };
  },
  S_DAP_HOME: ({ name = '', id = 0 }: any) => ({
    tag: 'S_DAPHome',
    params: {
      theme: Boolean(id),
      theme_name: name,
    },
  }),
  S_HOME_VIEW_MATERIALS: () => ({
    tag: 'S_HomeViewMaterials',
  }),
  ADD_CLASS_ROOM: ({ source = 'dap' }: any) => ({
    tag: 'AddClassroom',
    params: { source },
  }),
  ADD_CENTER: () => ({
    tag: 'AddCenter',
  }),
  ADD_STAFF: ({ role }: any) => {
    if (role === 'administrator') {
      role = 'admin';
    }

    return {
      tag: 'AddStaff',
      params: { role },
    }
  },
  S_CREATE_PLAN: () => ({
    tag: 'S_CreatePlan',
    params: { source: localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVITY_VIEW_SOURCE) },
  }),
  S_HOMEPASTPLANS: () => ({
    tag: 'S_HomePastPlans',
  }),
  PLAN_CREATED: ({ weeks = 1, theme = '' }: any) => ({
    tag: 'PlanCreated',
    params: {
      weeks,
      theme,
      source: localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVITY_VIEW_SOURCE),
    },
  }),
  S_DAP_ACTIVITIES_EMPTY_STATE: ({ plansScheduled }: any) => ({
    tag: 'S_DAPActivitiesEmptyState',
    params: { plansScheduled },
  }),
  S_SETTINGS_CENTERS: () => ({ tag: 'S_SettingsCenters' }),
  S_SETTINGS_STAFF: () => ({ tag: 'S_Staff' }),
  S_SETTINGS_BILLING: () => ({ tag: 'S_SettingsPayment' }),
  S_OB_PERSONALIZED_PLAN: () => ({ tag: 'S_OBPersonalizePlan' }),
  S_OB_PROFILE: () => ({ tag: 'S_OBProfile' }),
  CREATE_PERSONALIZED_PLAN: (params = {}) => ({ tag: 'CreatePersonalizePlan', params }),
  CREATE_PROFILE: (params = {}) => ({ tag: 'OBCreateProfile', params }),
  S_PREMIUM_PROCESS: () => ({
    tag: 'S_PremiumProcess',
    params: {
      source: localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVITY_VIEW_SOURCE),
    },
  }),
  S_SHARE_ACTIVITY: () => ({ tag: 'S_ShareActivity' }),
  S_SHARE_LESSON_PLAN: () => ({ tag: 'S_ShareLessonPlan' }),
  SHARE_ACTIVITY: (params: any) => {
    params = {
      ...params,
      source: localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVITY_VIEW_SOURCE),
      dap_type: localStorage.getItem(KEYS_LOCALSTORAGE.DAP_TYPE),
    };

    return ({
      tag: 'ShareActivity',
      params,
    });
  },
  SHARE_LESSON_PLAN: () => {
    const params: any = {
      source: localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVITY_VIEW_SOURCE),
    };
    const dap_type = localStorage.getItem(KEYS_LOCALSTORAGE.DAP_TYPE);
    if (dap_type && dap_type !== 'catalog') {
      params.dap_type = dap_type;
    }
    return ({
      tag: 'ShareLessonPlan',
      params,
    });
  },
  COMPLETE_REGISTRATION: () => ({ tag: 'CompleteRegistration' }),
  VIEW_CONTENT: () => ({ tag: 'ViewContent' }),
  CUSTOMIZE_PRODUCT: () => ({ tag: 'CustomizeProduct' }),
  S_UPLOAD_ACT_GENERAL: () => ({ tag: 'S_UploadActGeneral' }),
  S_UPLOAD_MILESTONES: () => ({ tag: 'S_UploadMilestones' }),
  S_UPLOAD_PERMISSIONS: () => ({ tag: 'S_UploadPermissions' }),
  CREATE_COLLECTION: ({ collection_name, share_center = 'no', share_organization = 'no' }: any) => ({
    tag: 'CreateCollection',
    params: {
      collection_name,
      share_center,
      share_organization,
      role: localStorage.getItem(KEYS_LOCALSTORAGE.USER_TYPE),
    },
  }),
  S_UPLOAD_COLLECTIONS: () => ({
    tag: 'S_UploadCollections',
  }),
  UPLOAD_ACTIVITY_EVENT: (params: any) => ({
    tag: 'UploadActivity',
    params,
  }),
  CREATE_CATEGORY: (params: { folder_type: string }) => ({
    tag: 'CreateCategory',
    params,
  }),
  // category and subcategory
  DELETE_CATEGORY: (params: { folder_type: string }) => ({
    tag: 'DeleteCategory',
    params,
  }),
  DELETE_RESOURCE: (params: { resource_type: string }) => ({
    tag: 'DeleteResource',
    params,
  }),
  UPLOAD_RESOURCE: (params: any) => ({
    tag: 'UploadResource',
    params,
  }),
  // done
  SHARE_RESOURCE: (params: any) => ({
    tag: 'ShareResource',
    params,
  }),
  S_SHARE_RESOURCE: (params: { resource_type: string, screen_type: string }) => ({
    tag: 'S_ShareResource',
    params,
  }),
  // done
  S_RESOURCES: (params?: { source: string }) => ({
    tag: 'S_Resources',
    params,
  }),
  // done
  S_LINK_ACTIVITY_COLLECTIONS: (params: any) => ({
    tag: 'S_LinkToActivityToCollections',
    params,
  }),
  // done
  S_LINK_RESOURCE_TO_ACTIVITY: (params: { source?: string }) => ({
    tag: 'S_LinkToActivity',
    params,
  }),
  // done
  LINK_TO_ACTIVITY: (params: any) => ({
    tag: 'LinkToActivity',
    params,
  }),
  // done
  S_CREATE_RESOURCE: (params: any) => ({
    tag: 'S_CreateResource',
    params,
  }),
  RemoveDap: () => ({
    tag: 'RemoveDap',
  }),
  S_SCHEDULE_ACTIVITY_TO_CENTER: () => ({
    tag: 'S_ScheduleActivityToCenter',
  }),
  S_SCHEDULE_ACTIVITY_TO_CLASSROOM: () => ({
    tag: 'S_ScheduleActivityToClassroom',
  }),
  S_SCHEDULE_ACTIVITY_TO_DAP: () => ({
    tag: 'S_ScheduleActivityToDap',
  }),
  S_SCHEDULEA_CTIVITY: () => ({
    tag: 'S_ScheduleActivity',
  }),
  SCHEDULE: ({ area_id, dap_type }: any) => ({
    tag: 'Schedule',
    params: {
      area: AreaDetail[area_id]?.name,
      dap_type,
    },
  }),
  EVENT_CREATED: ({
    event_type,
    event_duration,
    notification,
    user_role,
    recurrence,
  }: any) => ({
    tag: 'EventCreated',
    params: {
      event_type,
      event_duration,
      notification,
      user_role,
      recurrence,
    },
  }),
  EVENT_MODIFIED: ({ sendEmail }: { sendEmail: boolean }) => ({
    tag: 'EventModified',
    params: {
      sendEmail,
    },
  }),
  EVENT_DELETED: ({ sendEmail }: { sendEmail: boolean }) => ({
    tag: 'EventDeleted',
    params: {
      sendEmail,
    },
  }),
  S_CREATE_EVENT: ({
    user_role,
  }: any) => ({
    tag: 'S_CreateEvent',
    params: {
      user_role,
    },
  }),
  S_CALENDAR_HOME: ({ center_name }: any) => ({
    tag: 'S_CalendarHome',
    params: {
      center_name,
    },
  }),
  S_DAILY_PREVIEW: () => ({
    tag: 'S_DailyPreview',
  }),
  S_EVENT_DETAIL: () => ({
    tag: 'S_EventDetail',
  }),
  S_STUDENT_PROFILE: ({ source, tab_profile = '' }: any) => ({
    tag: 'S_StudentProfile',
    params: {
      source,
      tab_profile,
    },
  }),
  S_NEW_ANNOUNCEMENT: () => ({
    tag: 'S_NewAnnouncement',
  }),
  NEW_ANNOUNCEMENT: ({ attachments }: any) => ({
    tag: 'NewAnnouncement',
    params: {
      role: localStorage.getItem(KEYS_LOCALSTORAGE.USER_TYPE),
      attachments,
    },
  }),
  DELETE_MESSAGE: ({ type }: any) => ({
    tag: 'DeleteMessage',
    params: {
      type,
    },
  }),
  MESSAGE_DELETED: (data: any = {}) => ({
    tag: 'MessageDeleted',
    params: {
      ...data,
    },
  }),
  S_MESSAGES: () => ({
    tag: 'S_Messages',
  }),
  SEND_CHAT_MESSAGE: (data : any) => ({
    tag: 'SendChatMessage',
    params: {
      user_role: localStorage.getItem(KEYS_LOCALSTORAGE.USER_TYPE),
      ...data,
    },
  }),
  S_GROUP_CHAT_VIEW: (data: any) => ({
    tag: 'GroupChatView',
    params: {
      user_role: localStorage.getItem(KEYS_LOCALSTORAGE.USER_TYPE),
      ...data,
    },
  }),
  S_GROUP_CHAT_INFO: (data: any) => ({
    tag: 'S_GroupChatInfo',
    params: {
      ...data,
    },
  }),
  OPEN_GROUP_CHAT: (data: any) => ({
    tag: 'OpenGroupChat',
    params: {
      ...data,
    },
  }),
  ADD_GROUP_CHAT: (data: any) => ({
    tag: 'AddGroupChat',
    params: {
      user_role: localStorage.getItem(KEYS_LOCALSTORAGE.USER_TYPE),
      ...data,
    },
  }),
  EDIT_GROUP_CHAT: (data: any) => ({
    tag: 'EditGroupChat',
    params: {
      user_role: localStorage.getItem(KEYS_LOCALSTORAGE.USER_TYPE),
      ...data,
    },
  }),
  ADD_PEOPLE: (data: any) => ({
    tag: 'AddPeople',
    params: {
      ...data,
    },
  }),
  DELETE_GROUP_CHAT: (data: any) => ({
    tag: 'DeleteGroupChat',
    params: {
      ...data,
    },
  }),
  ADD_GROUP_CHAT_PARTICIPANT: (data: any) => ({
    tag: 'AddPeople',
    params: {
      user_role: localStorage.getItem(KEYS_LOCALSTORAGE.USER_TYPE),
      ...data,
    },
  }),
  DELETE_GROUP_CHAT_PARTICIPANT: (data: any) => ({
    tag: 'RemoveParticipant',
    params: {
      user_role: localStorage.getItem(KEYS_LOCALSTORAGE.USER_TYPE),
      ...data,
    },
  }),
  GROUP_CHAT_PARTICIPANT_DELETED: ({ participant_type: type }: any) => ({
    tag: 'ParticipantRemoved',
    params: {
      user_role: localStorage.getItem(KEYS_LOCALSTORAGE.USER_TYPE),
      type,
    },
  }),
  GROUP_CHAT_INFO_STEP: (data: any) => ({
    tag: 'GroupChatInfoStepCompleted',
    params: {
      ...data,
    },
  }),
  SELECT_GROUP_CHAT_AUDIENCE: (data: any) => ({
    tag: 'AudienceStepCompleted',
    params: {
      ...data,
    },
  }),
  SELECT_GROUP_CHAT_STAFF_MEMBERS: (data: any) => ({
    tag: 'StaffMembersStepCompleted',
    params: {
      ...data,
    },
  }),
  SELECT_GROUP_CHAT_STUDENTS: (data: any) => ({
    tag: 'GroupChatStudentsStepCompleted',
    params: {
      ...data,
    },
  }),
  SKIP_GROUP_CHAT_STEP: (data: any) => ({
    tag: 'GroupChatStepSkipped',
    params: {
      ...data,
    },
  }),
  APPCUES_WIDGET_CLICK: ({ source }: any) => ({
    tag: 'AppcuesWidgetClick',
    params: {
      source,
    },
  }),
  S_PORTFOLIO: (params: { tab_portfolio: string }) => ({
    tag: 'S_Portfolio',
    params,
  }),
  ASSIGN_MODERATOR: (params: { data: any }) => ({
    tag: 'AssignModerator',
    params,
  }),
  FILTERS: (params: { unread: boolean }) => ({
    tag: 'Filters',
    params,
  }),
  EXPORT_DATA: (params: any) => ({
    tag: 'ExportData',
    params,
  }),
  DATA_EXPORTED: (params: any) => ({
    tag: 'DataExported',
    params,
  }),
  S_FEED: () => ({ tag: 'S_Feed' }),
  FEED_TAB: () => ({ tag: 'FeedTab' }),
  VIEW_MORE_MILESTONES: (source: string) => ({
    tag: 'ViewMoreMilestones', params: { source },
  }),
  VIEW_LESS_MILESTONES: (source: string) => ({
    tag: 'ViewLessMilestones', params: { source },
  }),
  VIEW_ACTIVITY: (source: string) => ({
    tag: 'ViewActivity', params: { source },
  }),
  VIEW_LESSON_PLAN: () => ({ tag: 'ViewLessonPlan' }),
  VIEW_ARTICLE: () => ({ tag: 'ViewArticle' }),
  VIEW_RESOURCE: (source: string) => ({
    tag: 'ViewResource', params: { source },
  }),
  FILTER_JUMP_TO_FILTER: (source: string) => ({
    tag: 'JumpToFilter',
    params: { date_type: source },
  }),
  FEED_FILTER: (params: Object) => ({
    tag: 'FeedFilter', params,
  }),
};
